'use client'

import dynamic from "next/dynamic"
import { HeadingText } from "@/components/atoms/HeadingText/heading-text"
import { Placeholder } from "@/components/atoms/Placeholder/placeholder"

const DynamicMap = dynamic(() => import("@/components/molecules/Map/map").then(m => m.default), {
  loading: Placeholder,
  ssr: true,
})

export const MapSection = ({ coordinates, title }: { coordinates: any, title: string }) => {
  if (!coordinates) return null;

  return (
    <div className="flex max-h-96 w-full flex-col overflow-hidden rounded-xl bg-gray-50 p-5 px-5 py-6 dark:bg-black">
      <HeadingText level={3} className="border-b py-6">
        {title}
      </HeadingText>
      <DynamicMap coordinates={coordinates} />
    </div>
  )
}
